"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sync = exports.scanAccounts = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var Ripple_1 = require("../../api/Ripple");
var jsHelpers_1 = require("../../bridge/jsHelpers");
var operation_1 = require("../../operation");
var account_1 = require("../../account");
var js_1 = require("./bridge/js");
var txToOperation = function (accountId, address) {
    return function (_a) {
        var delivered_amount = _a.meta.delivered_amount, _b = _a.tx, DestinationTag = _b.DestinationTag, Fee = _b.Fee, hash = _b.hash, inLedger = _b.inLedger, date = _b.date, Account = _b.Account, Destination = _b.Destination, Sequence = _b.Sequence;
        var type = Account === address ? "OUT" : "IN";
        var value = delivered_amount && typeof delivered_amount === "string"
            ? new bignumber_js_1["default"](delivered_amount)
            : new bignumber_js_1["default"](0);
        var feeValue = new bignumber_js_1["default"](Fee);
        if (type === "OUT") {
            if (!Number.isNaN(feeValue)) {
                value = value.plus(feeValue);
            }
        }
        // https://xrpl.org/basic-data-types.html#specifying-time
        var toEpochDate = (946684800 + date) * 1000;
        var op = {
            id: (0, operation_1.encodeOperationId)(accountId, hash, type),
            hash: hash,
            accountId: accountId,
            type: type,
            value: value,
            fee: feeValue,
            blockHash: null,
            blockHeight: inLedger,
            senders: [Account],
            recipients: [Destination],
            date: new Date(toEpochDate),
            transactionSequenceNumber: Sequence,
            extra: {}
        };
        if (DestinationTag) {
            op.extra.tag = DestinationTag;
        }
        return op;
    };
};
var filterOperations = function (transactions, accountId, address) {
    return transactions
        .filter(function (tx) {
        return tx.tx.TransactionType === "Payment" &&
            typeof tx.meta.delivered_amount === "string";
    })
        .map(txToOperation(accountId, address))
        .filter(Boolean);
};
var getAccountShape = function (info) { return __awaiter(void 0, void 0, void 0, function () {
    var address, initialAccount, currency, derivationMode, accountId, accountInfo, serverInfo, oldOperations, startAt, ledgers, minLedgerVersion, maxLedgerVersion, balance, newTransactions, newOperations, operations, shape;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                address = info.address, initialAccount = info.initialAccount, currency = info.currency, derivationMode = info.derivationMode;
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: address,
                    derivationMode: derivationMode
                });
                return [4 /*yield*/, (0, Ripple_1.getAccountInfo)(address)];
            case 1:
                accountInfo = _a.sent();
                if (!accountInfo || accountInfo.error === js_1.NEW_ACCOUNT_ERROR_MESSAGE) {
                    return [2 /*return*/, {
                            id: accountId,
                            xpub: address,
                            blockHeight: 0,
                            balance: new bignumber_js_1["default"](0),
                            spendableBalance: new bignumber_js_1["default"](0),
                            operations: [],
                            operationsCount: 0
                        }];
                }
                return [4 /*yield*/, (0, Ripple_1.getServerInfo)()];
            case 2:
                serverInfo = _a.sent();
                oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
                startAt = oldOperations.length
                    ? (oldOperations[0].blockHeight || 0) + 1
                    : 0;
                ledgers = serverInfo.info.complete_ledgers.split("-");
                minLedgerVersion = Number(ledgers[0]);
                maxLedgerVersion = Number(ledgers[1]);
                balance = new bignumber_js_1["default"](accountInfo.account_data.Balance);
                return [4 /*yield*/, (0, Ripple_1.getTransactions)(address, {
                        ledger_index_min: Math.max(startAt, // if there is no ops, it might be after a clear and we prefer to pull from the oldest possible history
                        minLedgerVersion),
                        ledger_index_max: maxLedgerVersion
                    })];
            case 3:
                newTransactions = (_a.sent()) || [];
                newOperations = filterOperations(newTransactions, accountId, address);
                operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
                shape = {
                    id: accountId,
                    xpub: address,
                    blockHeight: maxLedgerVersion,
                    balance: balance,
                    spendableBalance: balance,
                    operations: operations,
                    operationsCount: operations.length
                };
                return [2 /*return*/, shape];
        }
    });
}); };
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape: getAccountShape });
//# sourceMappingURL=js-synchronization.js.map